import React from "react";
import { ColorWrap, Saturation, Hue, Alpha } from "react-color/lib/components/common";
import Pointer from "./pointer";
import PointerCircle from "react-color/lib/components/photoshop/PhotoshopPointerCircle";

function ColorPicker(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 150,
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(Saturation, Object.assign({}, props, {
    pointer: PointerCircle
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 10,
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(Hue, Object.assign({}, props, {
    pointer: Pointer
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: 10,
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(Alpha, Object.assign({}, props, {
    pointer: Pointer
  }))));
}

export default ColorWrap(ColorPicker);